import appConfigCoverGoProd from "./appConfigCoverGoProd.js"
import appConfigAWSDev from "./appConfigAWSDev.js"
import appConfigAWSProd from "./appConfigAWSProd";

import { COVERGO_SAAS_PROD } from "../consts.js"

const FILIFE_AWS_DEV = {
	COVERGO_GRAPHQL: "https://api.covergo-dev.fi.life/graphql",
	COVERGO_FILE_SYSTEM: "https://api.covergo-dev.fi.life/api/v1/files"
}

const FILIFE_AWS_PROD = {
	COVERGO_GRAPHQL: "https://api.covergo-prod.fi.life/graphql",
	COVERGO_FILE_SYSTEM: "https://api.covergo-prod.fi.life/api/v1/files",
}

export const fiLife = {
	// CoverGo PROD
	"fiLife-uat-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_PROD },

	// AWS DEV
	"studio.covergo-dev.fi.life": { appConfig: appConfigAWSDev, envConfig: FILIFE_AWS_DEV },

	// AWS Prod
	"studio.covergo-prod.fi.life": { appConfig: appConfigAWSProd, envConfig: FILIFE_AWS_PROD }
}
